import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import {ConfigProvider} from 'vant'
import axios from '@/utils/axios'
import mitt from 'mitt'
import clickOutside from '@/directives/click-outside'
import 'lib-flexible/flexible'
// styles
import '@/assets/styles/index.scss'

const app = createApp(App)
app
  .use(Vant)
  .use(ConfigProvider)
  .use(store)
  .use(router)
  .mount('#app')

app.directive('clickOutside', clickOutside)

app.config.globalProperties.$axios = axios
app.config.globalProperties.$mitt = mitt()